import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'
import exclamation from '../../../assets/svg/exclamationmark.svg'
import {
    ButtonAction,
    ButtonsContainer,
    ContentContainer,
    dialogPanel
} from './styles'

interface WarningModalProps {
    handleCloseModal: () => void
    leftButtonAction:()=>void
    rightButtonAction:()=>void
    isOpen: boolean
    title?:string
    subTitle?:string
    leftButtonText?: string
    rightButtonText?: string
    icon: JSX.Element
    customStyle?: {
        titleStyle?:string
        subtitleStyle?:string
    }
    
}

const WarningModal: React.FC<WarningModalProps> = ({
    handleCloseModal,
    leftButtonAction,
    rightButtonAction,
    isOpen,
    title,
    leftButtonText,
    rightButtonText,
    subTitle,
    icon,
    customStyle
}) => {
    return (
        <>
            <Transition
                appear
                show={isOpen}
                as={Fragment}
                data-testid="test-warningModal"
            >
                <Dialog
                    as="div"
                    className="relative z-10"
                    onClose={handleCloseModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className={dialogPanel}>
                                    <ContentContainer data-testid='test-modal-content'>
                                        {icon}
                                        <p className={`font-semibold text-base mt-4 ${customStyle?.titleStyle}`}>
                                        {title}
                                        </p>
                                        <span className={`max-w-[416px] text-center mt-4 ${customStyle?.subtitleStyle}`}>
                                        {subTitle}
                                        </span>
                                        <ButtonsContainer className='md:flex-row flex-col-reverse'>
                                            <ButtonAction
                                                onClick={() => {
                                                    leftButtonAction()
                                                }}
                                                type="button"
                                                className="text-blueTheme text-sm"
                                            >
                                                {leftButtonText}
                                            </ButtonAction>
                                            <ButtonAction
                                                onClick={() => {
                                                    rightButtonAction()
                                                }}
                                                className="bg-blueTheme text-white text-sm"
                                            >
                                                {rightButtonText}
                                            </ButtonAction>
                                        </ButtonsContainer>
                                    </ContentContainer>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}

export { WarningModal }
